import { Boxes, UsersRound } from 'lucide-react';
import { concernKey, DECISION_CONCERN_LABELS, type ConcernItemKind, type ConcernTags } from '@shared/decision-concern';
import { formatPercent } from '@/lib/formatters';
import { StatusBadge } from '@/components/StatusBadge';

/**
 * SF-T-182: whether an item a run returned (a question, a suggestion, a proposed sub-task, a disputed
 * finding) is a Product or an Architecture concern, as Jev tagged it before the message was saved
 * (the message's `payload.concerns`). Nothing when it has no tag: Jev wasn't sure, or the message is
 * from before tagging.
 */
export function ConcernBadge({ concerns, kind, item }: { concerns?: ConcernTags; kind: ConcernItemKind; item: number | string }) {
  const tag = concerns?.[concernKey(kind, item)];
  if (!tag) return null;
  const label = DECISION_CONCERN_LABELS[tag.concern];
  const Icon = tag.concern === 'product' ? UsersRound : Boxes;
  return (
    <StatusBadge
      tone={tag.concern === 'product' ? 'info' : 'neutral'}
      size="sm"
      shape="square"
      className="align-middle"
      title={`${label} concern: Jev is ${formatPercent(tag.confidence, 'score')} sure. ${tag.concern === 'product' ? 'For product engineers or owners to decide.' : 'For architectural engineers to decide.'}`}
    >
      <Icon aria-hidden />
      {label}
    </StatusBadge>
  );
}
